import gwaCalculator from '../assets/gwacalculator.png'
import ticketSystem from '../assets/ticket-system.png'
import freedomWall from '../assets/freedom-wall.png'
import pasyaran from '../assets/pasyaran.jpg'
import university from '../assets/university.png'

const projectList = [
    {
      id: "1",
      name: "Freedom Wall",
      tech: "MongoDB, Express, Reactjs, NodeJS",
      image: freedomWall,
      clicked: false,
    },
    {
      id: "2",
      name: "Online Ticket System with QR Code Integration and Mobile Scanner Application",
      tech: "MongoDB, Redux, ReactJS, NodeJS, TailwindCSS, React Native, Firebase, Realm",
      image: ticketSystem,
      clicked: false,
    },
    {
      id: "3",
      name: "NWU GWA Calculator",
      tech: "Reactjs, TailwindCSS",
      image: gwaCalculator,
      clicked: false,
    },
    {
      id: "4",
      name: "PASYARAN: Exploring the World with Ease - A Tourism Mobile Application with Advanced Navigation System",
      tech: "ReactJs, React Native, Firebase, TailwindCSS, Styled",
      image: pasyaran,
      clicked: false,
    },
    {
      id: "5",
      name: "UNIVERSITY SUPREME STUDENT COUNCIL [HEAVILY EDITED]",
      tech: "ReactJs, SANITYCMS, TailwindCSS,",
      image: university,
      clicked: false,
    },
  ];

  export default projectList